import { Header } from "components/Header"
import { EmployeeForm } from "components/employee-form"
import { ar } from "i18n/ar"

export default function NewEmployee() {
  return (
    <>
      <Header title={ar.newEmployee} />
      <EmployeeForm />
    </>
  )
}
